import { Download } from "lucide-react";
import { Button } from "@themes/pollinator/ui/Button";
import { Image } from "@themes/pollinator/ui/Image";

export type Props = {
  /** Alt text for the image */
  alt: string;
  /** Image source URL */
  src: string;
  /** Download URL for the image */
  downloadUrl: string;
  /** Label for the download button */
  label?: string;
  /** Optional click handler for the download button */
  onClick?: () => void;
};

/**
 * A downloadable image asset component with preview and download button.
 */
export function DownloadableAssetImage({
  alt,
  src,
  downloadUrl,
  label = "Download image",
  onClick,
}: Props) {
  return (
    <div
      className="overflow-hidden flex flex-col rounded-md border border-brand-800 gap-0"
      data-testid="downloadable-asset-image"
    >
      <div className="w-full">
        <div className="overflow-hidden">
          <Image
            src={src}
            alt={alt}
            className="w-full object-contain"
            data-testid="downloadable-asset-image-preview"
          />
        </div>
      </div>
      <div className="flex justify-center px-6 py-6 border-t border-brand-800">
        <Button
          as="a"
          href={downloadUrl}
          target="_blank"
          download
          title={`Download ${alt}`}
          aria-label={`Download ${alt}`}
          variant="secondary"
          iconComponent={Download}
          data-testid="downloadable-asset-image-download"
          onClick={onClick}
        >
          {label}
        </Button>
      </div>
    </div>
  );
}

export default DownloadableAssetImage;

